import React from "react";
import { Button, ButtonGroup } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import ViewStreamIcon from "@material-ui/icons/ViewStream";

export default function HubViewToggle({ view, onChange, hubDisabled = false }) {
  const classes = useStyles();

  return (
    <ButtonGroup
      size="small"
      className={classes.viewToggle}
      aria-label="Overview or Hub"
    >
      <Button
        startIcon={<ViewStreamIcon fontSize="small" />}
        className={
          view === "Hubs"
            ? `${classes.toggleButton} ${classes.toggleButtonSelected}`
            : classes.toggleButton
        }
        onClick={() => onChange("Hubs")}
      >
        Overview
      </Button>
      <Button
        startIcon={<ViewModuleIcon fontSize="small" />}
        className={
          view === "Hub Overview"
            ? `${classes.toggleButton} ${classes.toggleButtonSelected}`
            : classes.toggleButton
        }
        onClick={() => onChange("Hub Overview")}
        disabled={hubDisabled}
      >
        Hub
      </Button>
    </ButtonGroup>
  );
}

const useStyles = makeStyles((theme) => ({
  viewToggle: {
    boxShadow: "none",
    width: "auto",
  },
  toggleButton: {
    textTransform: "none",
    fontWeight: 700,
    fontSize: "16px",
    padding: theme.spacing(0.5, 1.25),
    minWidth: 0,
    color: "rgb(135, 131, 131)",
    borderColor: "rgb(185, 181, 181)",
    backgroundColor: "white",
    "& .MuiButton-startIcon": {
      marginRight: 4,
    },
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  toggleButtonSelected: {
    color: theme.palette.primary.main,
    backgroundColor: "rgba(25, 118, 210, 0.08)",
    borderColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: "rgba(25, 118, 210, 0.12)",
    },
  },
}));
